import { useNavigate, useParams } from "react-router-dom";

import { useFormikContext } from "formik";

import { Tabs, Tab } from "components/layout";
import { RestrictedArea } from "containers/Permissions";
import { PATHS } from "pages/TiVoApps/constants";
import { pathToUrl } from "utils/url";
import { isTabInvalid } from "utils/validation";

import { FormMode, FormTabArray } from "./types";
import { useFormMode } from "./utils";

type CreateTabLinkProps = {
  id?: string; // provider id
  mode: FormMode;
  tabId: string;
  variantId?: string;
  versionId?: string;
};

export type TiVoAppFormTabsProps = {
  tabs: FormTabArray;
};

export const createTabLink = ({
  mode,
  id,
  tabId,
  variantId,
  versionId,
}: CreateTabLinkProps) => {
  const path = PATHS[mode];
  const params = {
    id: id ? encodeURIComponent(id) : "",
    tabId,
    variantId: variantId ? encodeURIComponent(variantId) : "",
    versionId: versionId ? encodeURIComponent(versionId) : "",
  };
  return pathToUrl(path, params);
};

export const getActiveTab = (
  tabs: FormTabArray,
  params: Record<string, string | undefined>
) => tabs.findIndex(({ path }) => path === params["*"]);

export function TiVoAppFormTabs({ tabs }: TiVoAppFormTabsProps) {
  const { errors } = useFormikContext();
  const navigate = useNavigate();
  const params = useParams();
  const mode = useFormMode();

  return (
    <Tabs>
      {tabs.map((tab, idx) => {
        const isValid = !isTabInvalid(tab.fields, errors);
        return (
          <RestrictedArea allowed={tab.allowed} showFallback={false}>
            <Tab
              key={tab.path}
              active={getActiveTab(tabs, params) === idx}
              text={tab.text}
              icon={isValid ? "ok" : "warning"}
              iconColor={isValid ? "success" : "error"}
              dataTestId={tab.dataTestId}
              onClick={() => {
                navigate(
                  createTabLink({
                    id: params.id,
                    mode,
                    tabId: tab.path,
                    variantId: params.variantId,
                    versionId: params.versionId,
                  })
                );
              }}
            />
          </RestrictedArea>
        );
      })}
    </Tabs>
  );
}
